import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { authenticatingUserSucceeded } from "src/redux/actions/users";
import _ from "lodash";

export const SSOSuccess: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const authenticated = useSelector((state: any) => _.get(state, 'users.authentication.authenticated'));

  useEffect(() => {
    const response = new URLSearchParams(location.search).get("response");
    if (response) {
      processSuccessResponse(response);
    }
  }, [location.search]);

  useEffect(() => {
    if (authenticated) {
      navigate("/hub");
    }
  }, [authenticated])

  const processSuccessResponse = (response: string) => {
    const decoded = atob(response);
    const jsonData = JSON.parse(decoded);
    dispatch(authenticatingUserSucceeded(jsonData));
  };

  return <div></div>;
};
